/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthenticateRequest } from '../../models/authenticate-request';
import { AuthenticateResponse } from '../../models/authenticate-response';

export interface Authenticate$Json$Params {
      body?: AuthenticateRequest
}

export function authenticate$Json(http: HttpClient, rootUrl: string, params?: Authenticate$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthenticateResponse>> {
  const rb = new RequestBuilder(rootUrl, authenticate$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthenticateResponse>;
    })
  );
}

authenticate$Json.PATH = '/api/Auth/authenticate';
